import axios from 'axios'
import Result from '../../utils/serviceResultPattern'

export default {
    moveInvoice(bookingId, invoiceId, destinationPaymentId) {
        return axios
            .patch('/api/payments/invoice/move', { bookingId: bookingId , invoiceId: invoiceId, destinationPaymentId: destinationPaymentId })
            .then((res) => Result.ok(res.data))
            .catch((error) => {
                const message = (error.response && error.response.data) || "We couldn't move the invoice at this time. Please try again or contact support if the issue persists."
                return Result.error(message)
            })
    },

    cancelInvoice(bookingId, bookingInvoiceId, chargebackReason) {
        return axios
            .get('/api/Invoice/cancel', {
                params: { bookingId, bookingInvoiceId, chargebackReason }
            })
            .then((res) => Result.ok(res.data))
            .catch((error) => {
                const message = (error.response && error.response.data) || "We couldn't cancel the invoice at this time. Please try again or contact support if the issue persists."
                return Result.error(message)
            })
    },
}



// WEBPACK FOOTER //
// ./src/api/reservation/invoiceService.js